(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/map-interval.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/map-interval.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useState = _React.useState;
const getIntervalResultMapHandler = svs.lyckoplatsen.components.shared_map.getIntervalResultMapHandler;
const getHomeLocationCoordinates = svs.tur.lyckoplatsen.map.getHomeLocationCoordinates;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  overlayResultAtom = _svs$lyckoplatsen$com.overlayResultAtom,
  showHomeLocationPinAtom = _svs$lyckoplatsen$com.showHomeLocationPinAtom;
const memoFetchResult = svs.lyckoplatsen.utils.page_result.memoFetchResult;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const mapErrorDialogNoRedirect = svs.lyckoplatsen.shared_map.utils.mapErrorDialogNoRedirect;
const Button = svs.ui.ReactButton;
const mapId = 'map-interval';
const MapInterval = _ref => {
  let results = _ref.results;
  const mapHandlerResult = useMemo(() => getIntervalResultMapHandler(), []);
  const intervalResults = results;
  const setOverlayResult = useSetAtom(overlayResultAtom);
  const showHomeLocationPin = useAtomValue(showHomeLocationPinAtom);
  const setShowHomeLocationPin = useSetAtom(showHomeLocationPinAtom);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mapReady = _useState2[0],
    setMapReady = _useState2[1];
  const hasHomeLocation = useMemo(() => Boolean(getHomeLocationCoordinates()), []);
  const handleHomeLocationClick = () => {
    if (showHomeLocationPin) {
      setShowHomeLocationPin(false);
      mapHandlerResult.removeHomeLocation();
      return;
    }
    setShowHomeLocationPin(true);
    mapHandlerResult.showHomeLocation();
  };

  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      maxBounds: [[72.1, -5.5], [47.1, 39.5]],
      maxZoom: 15,
      minZoom: 4,
      zoomSnap: 0.25,
      dragging: true,
      boxZoom: true,
      touchZoom: true,
      zoomControl: false,
      errorCallback: mapErrorDialogNoRedirect
    };
    const evtHandlers = {
      intervalPinClicked: async _ref2 => {
        let productId = _ref2.productId,
          drawNumber = _ref2.drawNumber;
        const result = await memoFetchResult(productId, drawNumber);
        setOverlayResult(result);
      }
    };
    mapHandlerResult.createMap({
      mapOptions,
      evtHandlers
    });
    mapHandlerResult.fitBoundsSweden();
    setMapReady(true);
    return () => {
      setMapReady(false);
      mapHandlerResult.removeMap();
    };
  }, [mapHandlerResult, setOverlayResult]);
  useEffect(() => {
    if (!mapReady) {
      return;
    }
    if (showHomeLocationPin) {
      mapHandlerResult.showHomeLocation({
        panToLocation: false
      });
    } else {
      mapHandlerResult.removeHomeLocation();
    }
  }, [mapHandlerResult, mapReady, showHomeLocationPin, intervalResults]);
  useEffect(() => {
    if (intervalResults !== null && intervalResults !== void 0 && intervalResults.length) {
      mapHandlerResult.centerMap();
      mapHandlerResult.showIntervalResult(intervalResults);
      return () => mapHandlerResult.removeIntervalResult();
    }
  }, [mapHandlerResult, intervalResults]);
  return React.createElement("div", {
    className: "result-map result-map-interval lp-result-details"
  }, React.createElement("div", {
    id: mapId,
    style: {
      height: '100%',
      width: '100%'
    }
  }), hasHomeLocation && React.createElement(Button, {
    className: "lp-btn-home-location",
    onClick: handleHomeLocationClick,
    "aria-pressed": showHomeLocationPin,
    "aria-label": "Visa hemadress"
  }, React.createElement("img", {
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/hemma.svg"),
    alt: ""
  })));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  MapInterval
});

 })(window);